<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div>
    <div
      v-if="false"
      style="position: fixed; bottom: 0; right: 0; z-index: 1000; height: 300px; width:300px; overflow: scroll; background: red;"
    >
      <!---  newContentMode: {{ newContentMode }}
      contentType: {{ contentType.name }}
      permissionToWrite: {{ store.getters.permissionToWrite }}
      canCreate: {{ canCreate }}
      contentValid: {{ contentValid }}
        content: {{ content }}
      -->
      pageBuilderConfigField: {{ pageBuilderConfigField }}
      pageBuilderConfig: {{ content?.[pageBuilderConfigField] }}
      loading: {{ loading }}
      contentValid: {{ contentValid }}
      content: {{ content }}
      originalContent: {{ originalContent }}
    </div>
    <!-- Linear loading -->
    <v-progress-linear v-if="loading" absolute height="6" color="grey" :indeterminate="true" />

    <!-- Didn't found content -->
    <v-alert v-if="notFound" type="error" class="mt-6">
      <div class="mb-2">
        <strong>Ups</strong>, looks something is not ok!<br>
        Please try again, if the problem persists make sure that this item exists and your connection.<br>
      </div>
      <v-btn outlined class="mr-2" @click="router.push({name: 'home'})">
        <v-icon>home</v-icon>
        <span class="ml-1">Back to Home</span>
      </v-btn>
    </v-alert>

    <!-- Workspace not selected -->
    <v-alert v-if="differentWorkspace" type="error" class="mt-6">
      <div class="mb-2">
        Content doesn't belong to "{{ store.getters.workspace.name }}" workspace! <br>
      </div>
      <v-btn outlined class="mr-2" @click="router.push({name: 'home'})">
        <v-icon>home</v-icon>
        <span class="ml-1">Back to Home</span>
      </v-btn>
      <v-btn outlined class="mr-2" @click="switchWorkspace(content.workspace)">
        <v-icon>work_outline</v-icon>
        <span class="ml-1">Change Workspace</span>
      </v-btn>
    </v-alert>

    <!-- Doesn't have permissions or the Content can't be create in this workspace -->
    <v-alert v-if="disallowedContentType" type="error" class="mt-6">
      <div class="mb-2">
        Can't create a {{ newContentTitle }} content <br>
      </div>
      <v-btn outlined class="mr-2" @click="router.push({ name: 'home' })">
        <v-icon>home</v-icon>
        <span class="ml-1">Back to Home</span>
      </v-btn>
    </v-alert>

    <div v-if="!differentWorkspace && !disallowedContentType">
      <v-row v-if="!loading && content" flat>
        <v-col col="12" class="d-flex align-center floating-bar">
          <!-- Go back button -->
          <a class="cursor-as-pointer" tag="button" @click="goBack">
            <v-btn icon>
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </a>

          <v-toolbar-title v-if="newContentTitle" class="py-2">Création {{ newContentTitle }}</v-toolbar-title>
          <Breadcrumbs v-else :path="content.path" :file-name="fileName" />

          <!-- Status of the content type -->
          <StatusDisplay
            v-if="contentType.configs.workflow && !newContentMode"
            class="ml-5 py-2"
            :status="content.status"
            :states="workflowStatus"
          />
          <v-spacer />

          <v-btn v-if="showOffersButton && !inlineEditorActive" icon @click="showOffersTable = !showOffersTable">
            <v-icon>mdi-table-large</v-icon>
          </v-btn>

          <v-btn v-if="showSEOEditor" icon @click="goToSEOEditor()">
            <v-icon>mdi-alpha-s-circle-outline</v-icon>
          </v-btn>

          <v-btn v-if="showInlineEditor" icon @click="startInlineEditor()">
            <v-icon>remove_red_eye</v-icon>
          </v-btn>

          <v-btn v-if="showPageBuilder" icon @click="startPageBuilder()">
            <v-icon>build</v-icon>
          </v-btn>

          <v-btn v-if="pageBuilderActive" icon @click="stopPageBuilder()">
            <v-icon>edit</v-icon>
          </v-btn>

          <v-btn v-if="showEmailOptions || emailBuilderActive" icon @click="openEmailModal()">
            <v-icon>mdi-email-send</v-icon>
          </v-btn>

          <v-btn v-if="showEmailOptions" icon @click="startEmailBuilder()">
            <v-icon>build</v-icon>
          </v-btn>

          <v-btn v-if="emailBuilderActive" icon @click="stopEmailBuilder()">
            <v-icon>edit</v-icon>
          </v-btn>

          <v-btn v-if="inlineEditorActive" icon @click="stopInlineEditor()">
            <v-icon>edit</v-icon>
          </v-btn>

          <!-- Create or workflow buttons -->
          <div v-if="store.getters.permissionToWrite">
            <v-btn v-if="newContentMode" :disabled="!canCreate" light class="mx-2" @click="create()">Save</v-btn>
            <WorkflowButtons
              v-else-if="showWorkFlowButtons"
              :workflow="contentType.configs.workflow"
              :status="content.status"
              :content-valid="contentValid"
              :save="update"
            />
          </div>

          <v-btn
            v-if="!newContentMode && store.state.currentUser.writeWorkspaces.length"
            icon
            @click.prevent="showContextMenu($event)"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <PageBuilder
        v-if="pageBuilderActive"
        ref="pageBuilder"
        builder-type="pageBuilder"
        send-information-flag="updatePageConfig"
        receive-information-flag="savePageBuilderConfig"
        :content-field="pageBuilderConfigField"
        :content.sync="content"
        :preview-url="pageBuilderURL"
        :loading.sync="loading"
        :mutation-success-message="mutationSuccessMessage"
        :system-information.sync="systemInformation"
      />

      <PageBuilder
        v-else-if="emailBuilderActive"
        ref="emailBuilder"
        builder-type="emailBuilder"
        send-information-flag="updateEmailConfig"
        receive-information-flag="saveEmailBuilder"
        :content-field="emailBuilderConfigField"
        :content.sync="content"
        :preview-url="emailBuilderURL"
        :loading.sync="loading"
        :mutation-success-message="mutationSuccessMessage"
        :system-information.sync="systemInformation"
      />

      <InlineEditor
        v-else-if="inlineEditorActive"
        :content-valid.sync="contentValid"
        :content.sync="content"
        :content-type="contentType"
        :loading.sync="loading"
      />
      <v-row v-else-if="!loading && content">
        <v-col cols="8">
          <v-alert
            v-for="error in mutationErrorMessages"
            v-if="mutationErrorMessages.length"
            :key="error.message"
            :type="error.type"
            transition="scale-transition"
            class="mb-6"
          >
            <v-row align="center" no-gutters>
              <v-col v-if="error.message" class="grow">{{ error.message }}</v-col>
              <v-col v-if="error.redirectLabel && error.redirectUrl" class="shrink px-2">
                <v-btn outlined small right target="_blank" :to="error.redirectUrl">
                  <v-icon small class="mr-2">open_in_new</v-icon> {{ error.redirectLabel }}
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>

          <v-card color="secondary" class="border-radius-0">
            <GenerateForm
              :raw-content-types="store.state.rawContentTypes"
              :content-valid.sync="contentValid"
              :content.sync="content"
              :content-type="contentType"
              :show-panel-labels="true"
            />
          </v-card>
        </v-col>
        <v-col v-if="!newContentMode" cols="4">
          <v-alert v-if="mutationSuccessMessage" type="success" transition="scale-transition" class="pa-3">
            {{ mutationSuccessMessage }}
          </v-alert>

          <!--- Warning message of content -->
          <ContentAdditionalInformation
            v-if="contentType.content_warnings"
            :content-type-warnings="contentType.content_warnings"
            :content="content"
          />

          <!-- OFFERS TABLE -->
          <OffersTable v-if="showOffersTable && !inlineEditorActive" :iresa-code="content[offersTableFieldName]" />

          <!--- Summary fields -->
          <ContentBox v-if="summaryFields.length > 0" :title="fileName" :fields="summaryFields" />

          <!--- Publishing -->
          <PublishingInformation
            :status="content.status"
            :states="workflowStatus"
            :published-at="content.publishedAt"
            :start-publication-date.sync="content.startPublicationDate"
            :end-publication-date.sync="content.endPublicationDate"
            :online.sync="content.online"
          />

          <!--- Metadata -->
          <ContentBox v-if="metaDataFields.length > 0" title="Meta-data" :fields="metaDataFields" />
        </v-col>
      </v-row>
    </div>
    <ContextMenu ref="contextMenu" />

    <CopyPastePopup ref="copyPastePopup" />

    <component
      :is="emailModalComponent"
      v-if="showEmailOptions || emailBuilderActive"
      ref="sendEmailPopUp"
      :uuid="content?.uuid"
      :send-mode="true"
      :show-error-message="writeErrorMsg"
      :show-success-message="showSuccessMessage"
    />

    <UnsavedChangesAlert />
  </div>
</template>

<script setup>

import { ref, computed, watch, onBeforeUnmount } from 'vue';

import { useRoute, useRouter } from 'vue2-helpers/vue-router';
import { useStore } from 'vue2-helpers/vuex';
import { useApolloClient, useQuery, useMutation } from '@vue/apollo-composable';

import _ from 'lodash';
import moment from 'moment';
import gql from 'graphql-tag';

import { getContentType, getTitleField, setDefaultValues } from '@/utils/content';
import { buildContentMutation, buildContentQuery, variablesInputSetup } from '@/utils/editor';
import { checkIfHasChanges } from '@/utils/pwa';

import { EventBus } from '../mixins';

import WorkflowButtons from '../components/editor/WorkflowButtons.vue';
import Breadcrumbs from '../components/editor/Breadcrumbs.vue';
import StatusDisplay from '../components/editor/StatusDisplay.vue';
import ContentAdditionalInformation from '../components/editor/ContentAdditionalInformation.vue';
import ContentBox from '../components/editor/ContentBox.vue';
import PublishingInformation from '../components/editor/PublishingInformation.vue';
import OffersTable from '../components/editor/OffersTable.vue';
import ContextMenu from '../components/contents/ContextMenu.vue';
import UnsavedChangesAlert from '@/components/editor/UnsavedChangesAlert.vue';
import InlineEditor from '../components/editor/InlineEditor.vue';
import PageBuilder from '../components/editor/PageBuilder.vue';
import CopyPastePopup from '@/components/editor/Customs/CopyPaste.vue';
import SpeedboatEmailModal from '@/components/editor/Customs/SpeedboatEmailModal.vue';
import AlphaEmailModal from '../components/editor/Customs/AlphaEmailModal.vue';
import { getGraphqlSchema } from '@/graphql/index';

const { allowedContentTypes } = require('../utils/permissions');
const { getValidContentTypes } = require('../utils/content');

const { resolveClient } = useApolloClient();

const apollo = resolveClient();

console.log('Content Editor Setup');

onBeforeUnmount(() => {
  EventBus.$off('showCopyPastePopup');
});

const store = useStore();
const router = useRouter();
const route = useRoute();

const loading = ref(false);

const goBack = () => {
  checkIfHasChanges(() => {
    router.go(-1);
  });
};

/** ******************
COMMON CONTENT
******************* */

const content = ref(null);

const wtype = computed(() => route.params.wtype);

const workspaceCode = computed(() => store.getters.workspace.code);

const contentType = computed(() => getContentType(wtype.value, store.state.rawContentTypes));

const contentValid = ref(false);

const mutationErrorMessages = ref([]);
const mutationSuccessMessage = ref(null);

const writeErrorMsg = msg => {
  if (!msg) {
    return;
  } if (!Array.isArray(msg)) {
    msg = [msg];
  }

  msg.forEach(error => {
    // if is single value
    if (typeof error === 'string') {
      mutationErrorMessages.value.push({ type: 'error', message: error });
    } else {
      mutationErrorMessages.value.push(error);
    }
  });

  // if (msg) { this.loading = false; }
};

const showSuccessMessage = msg => {
  mutationSuccessMessage.value = msg;
  if (msg) { setTimeout(callback => { callback(null); }, 7000, showSuccessMessage); }
};

/** ******************
CONTEXT MENU OF CONTENT (MOVE, COPY, DELETE, EXPORT)
******************* */

const contextMenu = ref(null);

const changePath = path => {
  content.value.path = path;
};

EventBus.$on('moveItemTo', changePath);

// Show context menu
const showContextMenu = e => {
  const item = {
    uuid: content.value.uuid,
    path: content.value.path,
    wtitle: fileName.value,
    wtype: content.value.wtype
  };

  contextMenu.value.show(e, item);
};

/** *******************
NEW CONTENT
******************* */

const createPath = route.query.directory;

const newContentMode = computed(() => !route.params.uuid);

const newContentTitle = computed(() => (newContentMode.value ? contentType.value.name : null));

const canCreate = computed(() => {
  const titleFieldName = getTitleField(contentType.value);
  return !!content.value[titleFieldName] && content.value[titleFieldName].trim() !== '';
});

const variablesCreate = computed(() => {
  let variables = { input: variablesInputSetup(contentType.value, store.state.rawContentTypes, content.value, 'draft', createPath, workspaceCode.value) };
  if (contentType.value.configs.pageBuilder || contentType.value.configs.emailBuilder) {
    variables = variablesPageBuilderSetup(variables);
  }
  return variables;
});

const mutationCreate = buildContentMutation(store.state.rawContentTypes, contentType.value, 'create');

const { mutate: mutationCreateContent, onDone: onDoneCreate, onError: onErrorCreate } = useMutation(gql(mutationCreate), () => ({ variables: variablesCreate.value }));

onErrorCreate(error => {
  loading.value = false;

  if (error.message) {
    writeErrorMsg(error.message);
  }

  if (error.graphQLErrors.length) {
    const pimErrors = error.graphQLErrors[0].extensions?.pimErrors;
    if (pimErrors) {
      writeErrorMsg(pimErrors);
    }
  }
});

onDoneCreate(r => {
  mutationErrorMessages.value = [];
  const data = r.data[contentType.value.configs.create];
  router.push({ name: 'ContentEditor', params: { wtype: wtype.value, uuid: data.uuid } });
  showSuccessMessage('Content created.');
});

function create () {
  loading.value = true;
  mutationErrorMessages.value = [];

  if (contentType.value.configs.pageBuilder && pageBuilderActive.value) {
    pageBuilder.value.sendInformation({ requestPageConfig: true });
    setTimeout(() => {
      mutationCreateContent();
    }, 200);
    return;
  }

  if (contentType.value.configs.emailBuilder && emailBuilderActive.value) {
    emailBuilder.value.sendInformation({ emailConfiguration: true });
    setTimeout(() => {
      mutationCreateContent();
    }, 200);

    return;
  }

  mutationCreateContent();
}

// If is in create mode
if (newContentMode.value) {
  content.value = {};
}

/** *******************
EDIT CONTENT
******************* */

// If content not found
const notFound = computed(() => !loading.value && !content.value && !newContentMode.value);

const differentWorkspace = computed(() => !notFound.value && !loading.value && content.value && content.value.workspace !== workspaceCode.value && !newContentMode.value);

const disallowedContentType = computed(() => {
  // Can't create content types that are not translated in the current locale or don't belong to the current workspace
  let contentTypesList = getValidContentTypes(store.state.rawContentTypes, store.getters.workspace, store.getters.locale);

  contentTypesList = contentTypesList.filter(a => a !== undefined);

  const { currentUser } = store.state;
  const currentWorkspace = store.getters.workspace;
  const currentProject = store.state.environment.PROJECT;

  // Check if the User has content type permission
  contentTypesList = allowedContentTypes(contentTypesList, currentUser.restrictions, currentWorkspace.code, currentProject);

  return !loading.value && !contentTypesList.find(ct => ct.configs?.wtype === wtype.value);
});

const originalContent = ref(setDefaultValues({}, contentType.value));

const fileName = computed(() => {
  const titleFieldName = getTitleField(contentType.value);
  return originalContent.value[titleFieldName];
});

// Get summary fields already ordered
const summaryFields = computed(() => {
  const formFields = [];

  // Runs the list of fields
  for (const key of Object.keys(contentType.value.fields)) {
    // Gets field object
    const field = { ...contentType.value.fields[key] };

    // Check if is a field to be displayed on the the form
    if (field.showInSummary) {
      let label = null;

      const value = Array.isArray(content.value[key]) ? content.value[key] : [content.value[key]];

      value.forEach((v, index) => {
        if (['Entity', 'Picker'].includes(field.viewType) && v) {
          const labelArray = [];

          const contentTypeAux = getContentType(v.wtype, store.state.rawContentTypes);
          Object.keys(contentTypeAux.fields).forEach(aux => {
            if (contentTypeAux.fields[aux].showInList && v[aux]) {
              labelArray.push(v[aux]);
            }
          });

          label = labelArray.length ? labelArray.join(' | ') : 'NO INFORMATION';
        }

        field.code = `${key}-${index}`;
        field.value = label || v;
        formFields.push(field);
      });
    }
  }

  return formFields.sort((a, b) => a.orderInSummary - b.orderInSummary);
});

const metaDataFields = computed(() => {
  const fields = [];
  const { lastUpdateTime, lastUpdateUserName, createTime, createUserName } = content.value;
  fields.push({ code: 'contentType', label: 'Content Type', value: contentType.value.name, type: 'text' });
  fields.push({ code: 'lastUpdateTime', label: 'Dernière modification', value: lastUpdateTime, type: contentType.value.fields.lastUpdateTime.type });
  fields.push({ code: 'lastUpdateUserName', label: 'Par', value: lastUpdateUserName, type: contentType.value.fields.lastUpdateUserName.type });
  fields.push({ code: 'createTime', label: 'Créé', value: createTime, type: contentType.value.fields.createTime.type });
  fields.push({ code: 'createUserName', label: 'Par', value: createUserName, type: contentType.value.fields.createUserName.type });

  return fields;
});

const hideWorkFlowButtons = ref(false);

const workflowStatus = computed(() => store.state.workflows[contentType.value.configs.workflow].states);

const showWorkFlowButtons = computed(() => {
  const hasWorkflow = contentType.value.configs.workflow;
  return hasWorkflow && !hideWorkFlowButtons.value;
});

const switchWorkspace = workspace => {
  const workspaceObject = store.getters.workspaces.find(w => w.code === workspace);
  if (workspaceObject) {
    store.commit('setWorkspace', workspaceObject);
  }
};

/** ************** GET INITIAL INFORMATION ************* */

const query = computed(() => gql(buildContentQuery(store.state.rawContentTypes, contentType.value)));

const variablesQuery = computed(() => ({ uuid: route.params.uuid }));

const enabled = ref(true);

if (newContentMode.value) {
  enabled.value = false;
}

watch(newContentMode, val => {
  enabled.value = !val;
});

store.commit('setHasChanges', false);

console.log('setHasChanges create');

watch(content, newVal => {
  const hasChanges = !_.isEqual(originalContent.value, newVal);
  store.commit('setHasChanges', hasChanges);
}, { deep: true });

const { onResult: onResultContent } = useQuery(
  query,
  variablesQuery,
  () => ({ enabled: enabled.value, fetchPolicy: 'no-cache', notifyOnNetworkStatusChange: true })
);

onResultContent(result => {
  if (result.loading) {
    content.value = null;
    loading.value = true;
    pageBuilderActive.value = false;
    emailBuilderActive.value = false;
    inlineEditorActive.value = false;
    mutationErrorMessages.value = [];
    return;
  }

  loading.value = false;

  const contentResponse = result.data[contentType.value.configs.single];

  if (contentResponse) {
    content.value = setDefaultValues({ ...contentResponse }, contentType.value);
    originalContent.value = setDefaultValues({ ...contentResponse }, contentType.value);
  }
});

// If is edit mode
if (!newContentMode.value) {
  loading.value = true;
}

/** ************** UPDATE INFORMATION ************* */

const updateStatus = ref('draft');
const variablesUpdate = computed(() => {
  let variables = { input: variablesInputSetup(contentType.value, store.state.rawContentTypes, content.value, updateStatus.value, content.value.path, workspaceCode.value) };

  if (contentType.value.configs.pageBuilder || contentType.value.configs.emailBuilder) {
    variables = variablesPageBuilderSetup(variables);
  }

  return variables;
});

const mutationUpdate = buildContentMutation(store.state.rawContentTypes, contentType.value, 'update');

const { mutate: mutationUpdateContent, onDone: onDoneUpdate, onError: onErrorUpdate } = useMutation(gql(mutationUpdate), () => ({ variables: variablesUpdate.value }));

onErrorUpdate(error => {
  loading.value = false;

  if (error.message) {
    writeErrorMsg(error.message);
  }

  if (error.graphQLErrors.length) {
    const pimErrors = error.graphQLErrors[0].extensions?.pimErrors;
    if (pimErrors) {
      writeErrorMsg(pimErrors);
    }
  }
});

onDoneUpdate(r => {
  loading.value = false;
  mutationErrorMessages.value = [];
  const data = r.data[contentType.value.configs.update];

  // Clear cache
  if (contentType.value.configs && contentType.value.configs.workflow) {
    const transition = store.state.workflows[contentType.value.configs.workflow].transitions.find(item => item.to === content.value.status);
    const workspaceSettings = store.getters.workspace.settings;

    if (transition && transition.copyTo === 'live' && workspaceSettings.clearFrontCaches && workspaceSettings.clearFrontCaches.on.includes(wtype)) {
      let site = '';
      if (workspaceSettings.siteRelation) {
        site = `/${workspaceSettings.siteRelation}`;
      }

      const url = `${workspaceSettings.clearFrontCaches.cf_domain}${site}${variablesUpdate.value.input.url}`;

      apollo.mutate({
        mutation: getGraphqlSchema('clearCFCache'),
        variables: { url: url }
      });
    }
  }

  // Maybe we can remove this condition because whenever data is saved we must wait 10 seconds for indexation process
  if (moment().subtract(10, 'seconds').isBefore(moment(data.lastUpdateTime))) {
    hideWorkFlowButtons.value = true;
    setTimeout(() => {
      hideWorkFlowButtons.value = false;
    }, 10000);
  }

  showSuccessMessage('Changes saved.');
  content.value = JSON.parse(JSON.stringify(data));
  originalContent.value = JSON.parse(JSON.stringify(data));
});

function update (newStatus = 'draft') {
  // console.log(variablesUpdate.value);

  updateStatus.value = newStatus;
  loading.value = true;
  mutationErrorMessages.value = [];

  if (contentType.value.configs.pageBuilder && pageBuilderActive.value) {
    pageBuilder.value.sendInformation({ requestPageConfig: true });
    setTimeout(() => {
      mutationUpdateContent();
    }, 200);
    return;
  }
  if (contentType.value.configs.emailBuilder && emailBuilderActive.value) {
    emailBuilder.value.sendInformation({ emailConfiguration: true });
    setTimeout(() => {
      mutationUpdateContent();
    }, 200);

    return;
  }

  mutationUpdateContent();
}

/** *******************
INLINE EDITOR
******************* */

const inlineEditorActive = ref(false);

const showInlineEditor = computed(() => !newContentMode.value && contentType.value.configs.inlineEditing && !inlineEditorActive.value);

const startInlineEditor = () => {
  inlineEditorActive.value = true;
  loading.value = true;
};

const stopInlineEditor = () => {
  inlineEditorActive.value = false;
};

/** *******************
SEO EDITOR
******************* */

const showSEOEditor = computed(() => !newContentMode.value && contentType.value.configs.seoEditing);

const goToSEOEditor = () => {
  router.push({ name: 'SEOContentEditor', params: { wtype: route.params.wtype, uuid: route.params.uuid } });
};

/** *******************
PAGE BUILDER
******************* */

const pageBuilderActive = ref(false);
const pageBuilder = ref(null);

const pageBuilderConfigField = computed(() => {
  if (contentType.value.configs.pageBuilder) {
    return contentType.value.configs.pageBuilderConfigField || 'page_config';
  }
  return null;
});

const showPageBuilder = computed(() => contentType.value.configs.pageBuilder && !pageBuilderActive.value);

const systemInformation = ref(null);

const startPageBuilder = () => {
  pageBuilderActive.value = true;
  loading.value = true;
};

const variablesPageBuilderSetup = variables => {
  if (systemInformation.value) {
    variables.systemInformation = systemInformation.value;
  } else {
    delete variables.input[pageBuilderConfigField.value];
  }
  return variables;
};

const stopPageBuilder = () => {
  loading.value = true;

  pageBuilder.value.sendInformation({ requestPageConfig: true });

  setTimeout(() => {
    loading.value = false;
    pageBuilderActive.value = false;
  }, 200);
};

const pageBuilderURL = computed(() => {
  const previewConf = store.getters.workspace.settings.VUE_APP_PREVIEW;
  const pageBuilderConf = store.getters.workspace.settings.VUE_APP_PAGEBUILDER;

  const workspace = previewConf.workspace ? `/${store.getters.workspace.code}` : '';
  const uuid = pageBuilderConf && pageBuilderConf.uuid ? `/${route.params.uuid}` : '';

  let locale = '';

  if (previewConf.locale) {
    if (store.getters.locale) {
      locale = `/${store.getters.locale}`;
    } else {
      locale = `/${previewConf.defaultPreviewLocale}`;
    }
  }

  return `${previewConf.url}/page-builder${locale}${workspace}${uuid}`;
});

/** *******************
EMAIL BUILDER
******************* */

const emailBuilderActive = ref(false);
const emailBuilder = ref(null);

const showEmailOptions = computed(() => contentType.value.configs.emailBuilder && !emailBuilderActive.value);

const emailBuilderConfigField = computed(() => {
  if (contentType.value.configs.emailBuilder) {
    return contentType.value.configs.emailBuilderConfigField || 'email_config';
  }
  return null;
});

const startEmailBuilder = () => {
  emailBuilderActive.value = true;
  loading.value = true;
};

const stopEmailBuilder = () => {
  loading.value = true;

  emailBuilder.value.sendInformation({ emailConfiguration: true });

  setTimeout(() => {
    loading.value = false;
    emailBuilderActive.value = false;
  }, 200);
};

const emailBuilderURL = computed(() => {
  const previewEmailConf = store.getters.workspace.settings.VUE_EMAIL_PREVIEW;
  return `${previewEmailConf.url}/email/${store.state.environment.PROJECT}/${store.getters.workspace.code}`;
});

const emailModalComponent = computed(() => {
  switch (store.state.environment.PROJECT) {
    case 'alpha':
      return AlphaEmailModal;
    default:
      return SpeedboatEmailModal;
  }
});

const sendEmailPopUp = ref(null);

const openEmailModal = () => {
  sendEmailPopUp.value.open();
};

/** *******************
  PRODUCT OFFERS
******************* */
const showOffersTable = ref(false);

const offersTableFieldName = ref(contentType.value.configs.iresaOffersTable);

const showOffersButton = computed(() => (contentType.value.configs && contentType.value.configs.iresaOffersTable && content.value[offersTableFieldName.value]));

/** *******************
CopyPaste Popup
******************* */

const copyPastePopup = ref(null);

const showCopyPastePopup = e => {
  console.log(e);
  copyPastePopup.value.open(e);
};

EventBus.$on('showCopyPastePopup', showCopyPastePopup);

</script>

<style>
.floating-bar {
  background-color: #343434;
  position: sticky;
  top: 64px;
  z-index: 2;
}

.modules-form {
  /*
        heights
          header - 64px
          floating-bar - 76px
          iframeModes - 52px
          card title - 64px
        bottom space == right space - 24px
      */
  height: calc(100vh - 280px);
}

.form-sidebar-pagebuilder-inlineeditor {
  max-height: calc(100vh - 256px);
  overflow-y: auto
}

.iframeModes {
  height: 40px !important;
}

/* .iframeModes .active i {
  border-bottom: 2px solid;
}

.iframeModes i:hover {
  border-bottom: 2px solid;
} */

.transparentIFrame {
  height: 100vh;
  width: 100%;
  position: absolute;
  background-color: transparent;
  opacity: 0;
}

.resp-iframe {
  /*
        heights
          header - 64px
          floating-bar - 76px
          iframeModes - 52px
        bottom space == right space - 24px
      */
  height: calc(100vh - 252px);
  width: 100%;
  border: 0
}

.side-form {
  overflow-y: auto;
  max-height: calc(100vh - 272px);
}
</style>
